import { render } from "./montureListe.vue?vue&type=template&id=72f7f999&scoped=true"
import script from "./montureListe.vue?vue&type=script&lang=js"
export * from "./montureListe.vue?vue&type=script&lang=js"

import "./montureListe.vue?vue&type=style&index=0&id=72f7f999&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f7f999"]])

export default __exports__